{
  "name": "ivm-meldpunt",
  "version": "1.3.9",
  "private": true,
  "engines": {
    "node": "22",
    "npm": "10"
  },
  "scripts": {
    "start": "node backend/dist/index.js",
    "ng": "ng",
    "batch": "cd backend && npm run batch",
    "typecheck": "tsc --noEmit --project tsconfig.app.json",
    "lint:check": "eslint src",
    "lint:fix": "eslint --fix src",
    "backend:watch": "cd backend && npm run dev:watch",
    "swagger": "cd backend && npm run swagger:external",
    "build": "cd backend && tsc && cd .. && ng build",
    "sdk": "cd backend && npm run sdk",
    "sdk:watch": "cd backend && npm run sdk:watch ",
    "angular:watch": "ng build --watch --configuration development",
    "dev:watch": "concurrently --names \"Angular,Backend,SDK\" -c \"bgGreen.bold,bgBlue.bold,bgMagenta.bold\" \"npm run angular:watch\" \"npm run backend:watch\" \"npm run sdk:watch\"",
    "postinstall": "cd backend && npm i",
    "release": "generate-release"
  },
  "config": {
    "generateRelease": {
      "files_to_version": [
        "azure-pipelines-docker-build.yml",
        "package.json",
        "package-lock.json",
        "backend/package.json",
        "backend/package-lock.json"
      ]
    }
  },
  "dependencies": {
    "@angular/animations": "^21.1.4",
    "@angular/common": "^21.1.4",
    "@angular/compiler": "^21.1.4",
    "@angular/core": "^21.1.4",
    "@angular/forms": "^21.1.4",
    "@angular/localize": "^21.1.4",
    "@angular/platform-browser": "^21.1.4",
    "@angular/platform-browser-dynamic": "^21.1.4",
    "@angular/router": "^21.1.4",
    "@microsoft/applicationinsights-web": "^2.8.18",
    "@ng-bootstrap/ng-bootstrap": "^20.0.0",
    "@popperjs/core": "2.11.8",
    "bootstrap": "5.3.8",
    "colors": "^1.4.0",
    "dayjs": "^1.11.13",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^21.0.0",
    "@angular-eslint/eslint-plugin": "^21.0.0",
    "@angular-eslint/eslint-plugin-template": "^21.0.0",
    "@angular-eslint/schematics": "^21.0.0",
    "@angular-eslint/template-parser": "^21.0.0",
    "@angular/build": "^21.1.4",
    "@angular/cli": "^21.1.4",
    "@angular/compiler-cli": "^21.1.4",
    "@openapitools/openapi-generator-cli": "^2.21.0",
    "@types/swagger-ui-express": "^4.1.8",
    "@typescript-eslint/eslint-plugin": "^8.55.0",
    "@typescript-eslint/parser": "^8.55.0",
    "concurrently": "^7.6.0",
    "dotenv": "^16.6.1",
    "eslint": "^8.57.1",
    "eslint-config-prettier": "^8.10.0",
    "eslint-plugin-imengine": "file:eslint",
    "eslint-plugin-prettier": "^4.2.1",
    "generate-release": "^1.1.1",
    "ng-recaptcha": "^13.2.1",
    "nodemon": "^2.0.22",
    "prettier": "^2.8.8",
    "tslint": "~6.1.0",
    "typescript": "~5.9.3",
    "webpack-bundle-analyzer": "^4.10.2"
  },
  "overrides": {
    "ng-recaptcha": {
      "@angular/core": "^21.0.0",
      "@angular/common": "^21.0.0",
      "@angular/forms": "^21.0.0"
    }
  }
}
